/**
 * Utility functions for handling memo dates safely
 */

/**
 * Safely parse a date string, returning a valid Date or epoch
 * @param {string} dateString - The date string to parse
 * @returns {Date} A valid Date object (epoch if invalid)
 */
export const safeParseDate = (dateString) => {
  if (!dateString) {
    return new Date(0); // Return epoch for missing dates
  }
  
  const date = new Date(dateString);
  
  // Check if date is valid
  if (isNaN(date.getTime())) {
    return new Date(0); // Return epoch for invalid dates
  }
  
  return date;
};

/**
 * Create a cutoff timestamp just before the given date
 * @param {string} dateString - The date string to create cutoff from
 * @returns {string|null} ISO string of cutoff time, or null if invalid
 */
export const createCutoffTime = (dateString) => {
  if (!dateString) return null;
  
  const date = new Date(dateString);
  
  // Check if date is valid
  if (isNaN(date.getTime())) {
    return null;
  }
  
  // Create cutoff 1ms before the date
  return new Date(date.getTime() - 1).toISOString();
};

/**
 * Compare function for sorting memos by created_at
 * @param {Object} a - First memo
 * @param {Object} b - Second memo
 * @returns {number} Sort comparison result
 */
export const compareMemosByDate = (a, b) => {
  const timeA = safeParseDate(a.created_at).getTime();
  const timeB = safeParseDate(b.created_at).getTime();
  return timeA - timeB;
};